import {
  DigitalMenuBasicInfoInterface,
  DigitalMenuDesignInterface,
  DigitalMenuQrCodeInterface,
  OptionsConfigInterface,
} from "@/interface/business/digital-menu.interface";
import { DigitalMenuBasicInfo, DigitalMenuDesign, DigitalMenuQrCode } from "@/modules/business/digital";

export class DigitalMenuOptions implements OptionsConfigInterface {
  business_name: string = "";
  facebook: string = "";
  instagram: string = "";
  basic_info: DigitalMenuBasicInfoInterface;
  design!: DigitalMenuDesignInterface;
  qr_code!: DigitalMenuQrCodeInterface;

  constructor(data?) {
    this.business_name = data?.business_name || "";
    this.facebook = data?.facebook || "";
    this.instagram = data?.instagram || "";
    this.basic_info = new DigitalMenuBasicInfo(data?.basic_info);
    this.design = new DigitalMenuDesign(data?.design);
    this.qr_code = new DigitalMenuQrCode(data?.qr_code);
  }
}
